/* eslint-disable complexity */
/* eslint max-depth: ["error", 3] */

export const findKeyValuePair = (keyValuePairs, text) => {

    // Find the key-value pair in the list that matches the text value.

    let i;

    if (text === '') {

        return {key: '', value: ''};

    }

    for (i = 0; i < keyValuePairs.length; i += 1) {

        const pair = keyValuePairs[i];

        if (pair.value.toUpperCase() === text.toUpperCase()) {

            return pair;

        }

    }

    return {key: '', value: ''};

};

export const findValueKeyPair = (keyValuePairs, text) => {

    // Find the key-value pair in the list that matches the text value.

    let i;

    if (text === '') {

        return {key: '', value: ''};

    }

    if (!keyValuePairs || !Array.isArray(keyValuePairs)) {

        return {key: '', value: ''};

    }
    for (i = 0; i < keyValuePairs.length; i += 1) {

        const pair = keyValuePairs[i];

        if (pair.key && pair.key.toUpperCase() === text.toUpperCase()) {

            return pair;

        }

    }

    return {key: '', value: ''};

};



// WEBPACK FOOTER //
// ./src/rga/shared/services/rga-utils.js